import { Action, UserInputTask } from '@/utils/types';

/**
 * Finds the corresponding task for a given action from a list of user input tasks.
 */
export default function findTask(action: Action, tasks: Array<UserInputTask>) {
  return tasks.find((task) => task.action.id === action.id);
}
